
import { cls } from 'tagged-classnames-free';
const defaultItems: IProps['items'] = []
interface Item {
  label: string
  key: string
}
interface IProps {
  items?: Item[]
  onChange?: (activeKey: string) => void
  activeKey?: string
  className?: string
}
export default function Tabs(props: IProps) {
  const { items = defaultItems, activeKey, onChange, className } = props
  return (
    <div
      className={cls`bg-f-bg-container flex cursor-pointer rounded-lg ${className}`}
    >
      {items?.map((item) => (
        <div
          className={cls`
            flex h-9 flex-1 items-center justify-center rounded-md ${activeKey === item.key ? cls`bg-f-text text-f-text-invert` : cls`text-f-text-tertiary`}
          `}
          key={item.key}
          onClick={() => onChange?.(item.key)}
        >
          {item.label}
        </div>
      ))}
    </div>
  )
}
